import ChakraIntro from '../components/ChakraIntro';
import ChakraChannels from '../components/ChakraChannels';

const Chakras = () => {
  return (
    <main className="bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="max-w-7xl mx-auto space-y-24">
        {/* Chakra Introduction */}
        <section id="chakra-intro">
          <ChakraIntro />
        </section>

        {/* Chakra Channels */}
        <section id="chakra-channels">
          <ChakraChannels />
        </section>
      </div>
    </main>
  );
};

export default Chakras;
